import { render } from "./CouponGeneration.vue?vue&type=template&id=0f4c6e50&scoped=true&ts=true"
import script from "./CouponGeneration.vue?vue&type=script&lang=ts"
export * from "./CouponGeneration.vue?vue&type=script&lang=ts"

import "./CouponGeneration.vue?vue&type=style&index=0&id=0f4c6e50&scoped=true&lang=css"

import exportComponent from "C:\\Users\\hori_taiki\\Desktop\\小野写真館\\環境構築\\point-front-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4c6e50"]])

export default __exports__